// extracted by mini-css-extract-plugin
export default {"root":"Congratulation_root__Q6OdL","viewYouJustBurned":"Congratulation_viewYouJustBurned__xSHLB"};